import './App.css';
import React, { createRef, useEffect, useMemo, useState } from 'react';
import { createRoot } from 'react-dom/client'
import './global.scss';
import './sidebar.scss';
import Home from './pages/home/Home';

import axios from 'axios';
import {
  createBrowserRouter,
  RouterProvider,
  NavLink,
  useLocation,
  useOutlet,
} from 'react-router-dom'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { useParams, Link } from 'react-router-dom';
import Default from './pages/default';
import Blog from './pages/blog';
import Single from './pages/single';
import { NotificationContainer } from 'react-notifications';
import Header from './components/global/Header';
import AttorneyBio from './pages/attorney';
import SinglePAPage from './pages/practice-areas';
import Footer from './components/global/Footer';
import Category from './pages/blog/category';
import { NotFound } from './pages/404/404';

axios.defaults.baseURL = 'https://www.mylawteam.com/'; // production
// axios.defaults.baseURL = 'https://mylawteamstage.wpengine.com/'; // staging


const routes = [
  { path: '/', name: 'Home', element: <Home />, nodeRef: createRef() },
  { path: '/our-firm/:slug', name: 'AttorneyBio', element: <AttorneyBio />, nodeRef: createRef() },
  { path: '/practice-areas/:slug', name: 'SinglePAPage', element: <SinglePAPage />, nodeRef: createRef() },
  { path: '/practice-areas/:parentSlug/:slug', name: 'SinglePAPage', element: <SinglePAPage />, nodeRef: createRef() },
  { path: '/articles/:category/:slug', name: 'Default', element: <Single />, nodeRef: createRef()},
  { path: '/category/*', name: 'Category', element: <Category />, nodeRef: createRef() },
  { path: '/:slug', name: 'Default', element: <Default />, nodeRef: createRef() },
  { path: '/articles/', name: 'Blogs', element: <Blog />, nodeRef: createRef() },
  { path: '/404/', name: '404Notfound', element: <NotFound />, nodeRef: createRef() },
]


const router = createBrowserRouter([
  {
    path: '/',
    element: <Example />,
    children: routes.map((route) => ({
      index: route.path === '/',
      path: route.path === '/' ? undefined : route.path,
      element: route.element,
    })),
  },
]);


function Example() {
  const location = useLocation()
  const currentOutlet = useOutlet()
  const { nodeRef } =
    routes.find((route) => route.path === location.pathname) ?? {}

  // Trustindex loader: only inject when a #trustindex-widget container exists on the page
  useEffect(() => {
    const container = document.getElementById('trustindex-widget');
    if (!container) return;

    if (!document.querySelector('script[src*="trustindex.io"]')) {
      const s = document.createElement('script');
      s.src = 'https://cdn.trustindex.io/loader.js?32bde3568ab8461d2b56f4df32f';
      s.async = true;
      container.appendChild(s);
    } else if (window.Trustindex && typeof window.Trustindex.load === 'function') {
      window.Trustindex.load();
    }
  }, [location.pathname]);

  return (
    <>
      <div id="wrapper">
        <NotificationContainer />
        <Header />
        <main className='page-main-wrapper'>
          <SwitchTransition>
            
            <CSSTransition
              key={location.pathname}
              nodeRef={nodeRef}
              timeout={300}
              classNames="page"
              unmountOnExit
            >

              {(state) => (
                <>
                  <div ref={nodeRef} className="page">
                    {currentOutlet}
                  </div>
                </>
              )}
            </CSSTransition>
          </SwitchTransition>
        </main>
        <Footer  />
      </div>
    </>
  )
}
const container = document.getElementById('root')
const root = createRoot(container)
root.render(<RouterProvider router={router} />)
